import { FC, HTMLAttributes, useMemo } from 'react'

import { useDisplayFormState } from '@components/DisplayForm/hooks'

import { DropDownListLine, DropDownListLineProps } from '../DropDownListLine'

type DropDownListProps = {
  props: HTMLAttributes<HTMLLIElement>
} & Omit<DropDownListLineProps, 'liProps' | 'isDialogWindow'>

// TODO Это не List, это обертка Line
export const DropDownList: FC<DropDownListProps> = ({
  onUpdateRestrictions: handleUpdateRestrictions,
  combinedData,
  showSortOrder,
  isLoading,
  dropDownList,
  props,
  option,
  pkFieldName,
  columns,
}): React.ReactElement => {
  const { isFormDialogWindow } = useDisplayFormState()

  const dropDownListColumns = useMemo(() => columns?.filter(col => col.visibility) || [], [columns])

  return (
    <DropDownListLine
      key={option.id}
      columns={dropDownListColumns}
      combinedData={combinedData}
      dropDownList={dropDownList}
      isDialogWindow={isFormDialogWindow}
      isLoading={isLoading}
      liProps={props}
      option={option}
      pkFieldName={pkFieldName}
      showSortOrder={showSortOrder}
      onUpdateRestrictions={handleUpdateRestrictions}
    />
  )
}
